{
  "locale": "English",
  "sidebar": {
    "title": "Data sharing request",
    "issuanceTitle": "Request to add data",
    "authenticationTitle": "Authentication request",
    "description": "{clientName} is requesting verified personal data from your identity app. Review the details below and approve or decline this request in your identity app.",
    "issuanceDescription": "{clientName} is adding verified data to your identity app. Review the details below and confirm in your identity app whether you wish to accept.",
    "authenticationDescription": "{clientName} wants to authenticate with your identity app.",
    "descriptionFallback": "A service is requesting verified personal data from your identity app. Review the details below and approve or decline this request in your identity app.",
    "issuanceDescriptionFallback": "A service is adding verified data to your identity app. Review the details below and confirm in your identity app whether you wish to accept.",
    "authenticationDescriptionFallback": "A service wants to authenticate with your identity app.",
    "stepsTitle": "Steps to complete",
    "stepShareData": "Share data with {clientName}",
    "stepAuthenticate": "Authenticate for {clientName}",
    "stepReceiveData": "Receive data from {clientName}",
    "stepGeneric": "Complete the required steps",
    "defaultClientName": "the service",
    "requestedDataTitle": "The following data is being requested",
    "issuedDataTitle": "The following data will be issued",
    "reviewNotice": "You will review and approve the exact data in your identity app before anything is shared.",
    "issuanceReviewNotice": "You will review and approve the exact data in your identity app before anything is added.",
    "indeterminateHint": "The requested data will be visible after you have selected an identity app",
    "showAll": "Show all",
    "purposeStatementTitle": "Why your data is needed",
    "retentionPolicyTitle": "How your data is handled"
  },
  "footer": {
    "powered": "Powered by",
    "privacyPolicy": "Privacy policy"
  },
  "topBar": {
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "language": "Language"
  },
  "app": {
    "loadingTitle": "Loading"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Search",
    "noResults": "No results"
  },
  "init": {
    "title": "Processing request",
    "hint": "Setting up your session"
  },
  "pairing": {
    "title": "Preparing next step",
    "hint": "Setting up your session",
    "codeLabel": "Verify the following code in your identity app",
    "confirm": "Confirm pairing"
  },
  "waitingForPresentation": {
    "title": "Continue in your identity app",
    "hint": "Please check your identity app to review and approve the request"
  },
  "agentStart": {
    "title": "Continue in {appName}",
    "subtitle": "To securely share your data, scan this QR code with {appName} to review and approve the request.",
    "issuanceSubtitle": "To securely receive the data, scan this QR code with {appName} to review and approve the request.",
    "step1": "Open {appName}",
    "step2": "Click the scanner icon",
    "step3": "Scan this QR code",
    "changeApp": "Change identity app",
    "installInstructions": "Installation instructions",
    "cancel": "Cancel",
    "needHelp": "Need help?",
    "redirectSubtitle": "Click the button below to open {appName} and approve the request.",
    "issuanceRedirectSubtitle": "Click the button below to open {appName} and approve the request.",
    "redirectButton": "Continue",
    "mobileSubtitle": "To securely share your data, continue in {appName} to review and approve the request.",
    "issuanceMobileSubtitle": "To securely receive the data, continue in {appName} to review and approve the request.",
    "openApp": "Open {appName}",
    "showQr": "Show QR code"
  },
  "done": {
    "disclosure": {
      "title": "Data is successfully shared",
      "subtitle": "The page will automatically close in a few seconds.",
      "subtitleCloseTab": "Data successfully shared. Feel free to close this page."
    },
    "issuance": {
      "title": "Data successfully received",
      "subtitle": "The page will automatically close in a few seconds.",
      "subtitleCloseTab": "Data successfully received. Feel free to close this page."
    },
    "redirecting": "Redirecting...",
    "completeRedirect": "Complete & redirect",
    "redirectFailed": "Automatic redirect didn't work. Tap below to continue."
  },
  "abort": {
    "cancelled": {
      "title": "Process stopped",
      "subtitle": "You chose to stop the process. You can restart at any time."
    },
    "serverError": {
      "title": "Something went wrong",
      "subtitle": "We could not complete the process due to a technical issue."
    },
    "expired": {
      "title": "Session expired",
      "subtitle": "This session ended after a period of inactivity. To continue, close this page and restart the process."
    },
    "connectionLost": {
      "title": "Connection lost",
      "subtitle": "Your internet connection was interrupted. Please check your connection and try again."
    },
    "temporarilyUnavailable": {
      "title": "Service temporarily unavailable",
      "subtitle": "The service is currently undergoing maintenance. Please try again later."
    },
    "appError": {
      "title": "Identity app unavailable",
      "subtitle": "We could not connect to the selected identity app. The app may be temporarily unavailable. You can try a different identity app or try again later."
    },
    "contactOrganisation": {
      "subtitle": "We could not start the process. Please contact the organisation for help."
    },
    "selectDifferentApp": "Select different identity app",
    "confirmTitle": "Stop process?",
    "confirmMessage": "Are you sure you want to stop? You can restart at any time if you want to continue later.",
    "confirmStop": "Stop process",
    "goBack": "Go back",
    "leave": "Leave",
    "restart": "Restart",
    "retry": "Retry"
  },
  "appPicker": {
    "title": "Supported identity apps",
    "subtitle": "The following identity apps can be used to review and approve the request",
    "searchPlaceholder": "Search...",
    "sectionLastUsed": "Last used",
    "sectionRecommended": "Recommended",
    "sectionAZ": "A-Z",
    "noResults": "No apps match your search",
    "filterTitle": "Filter by country",
    "filterClear": "Clear all",
    "filterDone": "Done"
  },
  "faq": {
    "helpQuestion": "Question",
    "moreHelp": "More help",
    "close": "Close",
    "whatAreWallets": {
      "title": "What are identity apps?",
      "body": "An identity app lets you control your own data. You decide what you share, with whom, and when. Your data is retrieved from a verified issuer and stored in the app along with a digital signature that guarantees its accuracy.\n\nWhen you share data with a third party, the digital signature is included so they can verify it is authentic. Your data is usually stored only on your phone and can easily be retrieved again if needed.\n\nAlways be aware that it is your responsibility to carefully choose with whom you share your data."
    },
    "whyNotSupported": {
      "title": "Why is my identity app not supported?",
      "body": "Your specific identity app may not be available because the receiving party or our platform does not currently support it. We are constantly working to expand our range of supported apps.\n\nIf your app is not listed, you can always install and use one of the other supported identity apps."
    },
    "howDataProtected": {
      "title": "How is my data protected?",
      "body": "Identity apps give you full control over who you share your data with and when. They usually provide an overview of what you have shared, with whom, and when.\n\nVer.iD sends your data directly to the receiving party and only checks that it was delivered correctly.\n\nAlways be aware that it is your responsibility to carefully choose with whom you share your data.",
      "link": "Read more about security and privacy"
    },
    "howObtainData": {
      "title": "How can I put data in my app?",
      "body": "Each identity app has its own way of collecting data. Most apps have a button to add data, though in some cases there may be costs involved.\n\nFollow the instructions in your app to collect data securely. You may be redirected to government websites or asked to scan documents like passports or driving licenses.\n\nIf you cannot find a way to add the right data, check the app's documentation or contact the vendor. You can also try a different identity app."
    },
    "whyRedirection": {
      "title": "Why am I being redirected?",
      "body": "Some identity apps require a redirect to their own website so your data is shared in compliance with their standards, while maintaining the best experience in an environment you trust.\n\nAfter successfully sharing, you will be redirected back to Ver.iD where your data awaits your confirmation before being sent to the receiving party. A digital receipt is usually available in your identity app.\n\nIf the process fails or is cancelled, you will be redirected back and may have the option to retry."
    }
  },
  "mobileFlowStart": {
    "startVerification": "Continue"
  },
  "requestedDataModal": {
    "title": "Requested data",
    "subtitle": "You will review and approve this request in your identity app.",
    "attribute": "Attribute",
    "description": "Description",
    "issuedBy": "Data issued by",
    "close": "Close"
  },
  "demo": {
    "title": "Demo environment",
    "description": "You are using an interactive demo of Ver.iD. This environment is intended for demonstration purposes only."
  },
  "installInstructions": {
    "title": "Install {appName}",
    "subtitle": "Visit the App Store or Play Store on your phone to install {appName} identity app. Scan the code to directly open the store page to install the app.",
    "close": "Close",
    "unavailableTitle": "Instructions not available",
    "unavailableBody": "Sorry, we don't have any installation instructions for this app available at the moment. Try to manually search for the app in the app store to continue."
  },
  "embedded": {
    "loading": "Loading identity apps",
    "moreApps": "{count} more apps",
    "moreAppsOne": "1 more app",
    "useAnotherApp": "Use another app",
    "cancel": "Cancel",
    "back": "Back",
    "tryAgain": "Try again",
    "qr": {
      "caption": "Scan with {bold} to share your data.",
      "captionIssuance": "Scan with {bold} to add your data.",
      "label": "QR code to scan with {app}",
      "noApp": "No {app} app?",
      "whatShared": "What is shared?",
      "whatAdded": "What is added?",
      "expired": "This QR code has expired.",
      "refresh": "Refresh QR"
    },
    "waiting": {
      "title": "Continue in {app}",
      "sub": "Approve the request on your phone.",
      "subIssuance": "Accept the data on your phone.",
      "help": "Don’t see the request?"
    },
    "done": {
      "title": "Shared with {app}",
      "sub": "You can continue with your application.",
      "titleIssuance": "Added to {app}",
      "subIssuance": "Your data is now in the app."
    },
    "error": {
      "title": "Sharing didn’t finish",
      "sub": "Nothing was shared.",
      "titleIssuance": "Your data was not added",
      "subIssuance": "Nothing was added to {app}.",
      "help": "Why didn’t it finish?"
    },
    "unsupported": {
      "title": "{app} can’t be used here yet",
      "sub": "Use another app to continue."
    },
    "install": {
      "caption": "Install {bold} first: scan with your phone’s camera.",
      "label": "QR code to download {app} from your app store",
      "installed": "I have installed it"
    },
    "missing": {
      "title": "No install steps yet",
      "sub": "Install {app} the way its provider describes, then come back."
    },
    "notListed": {
      "title": "Don’t see your app?",
      "sub": "{org} accepts only these apps. Pick one to see how to install it.",
      "subIssuance": "{org} can add data only to these apps. Pick one to see how to install it.",
      "back": "Back to the apps"
    },
    "request": {
      "title": "Don’t see the request?",
      "sub": "Keep {app} open, it can take a few seconds. Still nothing? Scan the QR code again.",
      "keepWaiting": "Keep waiting",
      "scanAgain": "Scan again"
    },
    "why": {
      "title": "Why didn’t it finish?",
      "sub": "It was cancelled in {app} or took too long. Nothing was shared.",
      "subIssuance": "It was cancelled in {app} or took too long. Nothing was added."
    },
    "details": {
      "label": "What is shared",
      "caption": "Requested by {bold}. You approve it in your app first.",
      "back": "Back to the QR code",
      "labelIssuance": "What is added",
      "captionIssuance": "Issued by {bold}. You accept it in your app first.",
      "privacy": "Privacy policy",
      "security": "How is my data protected?"
    },
    "timeout": {
      "title": "This request has expired",
      "sub": "Requests stay open for a few minutes. Try again to get a new one."
    },
    "launch": {
      "title": "Share with {app}",
      "sub": "Tap Open {app} to see and approve the request.",
      "titleIssuance": "Add to {app}",
      "subIssuance": "Tap Open {app} to accept the data.",
      "open": "Open {app}"
    },
    "opening": {
      "sub": "Approve the request in the app.",
      "subIssuance": "Accept the data in the app.",
      "help": "{app} didn’t open?"
    },
    "notOpened": {
      "title": "{app} didn’t open?",
      "sub": "{app} may not be installed on this phone. Install it to continue.",
      "install": "Install {app}"
    },
    "phoneInstall": {
      "title": "{app} not on this phone?",
      "sub": "Get it from your app store, or scan with another device.",
      "get": "Get {app}",
      "scanOther": "Scan with another device"
    },
    "phoneQr": {
      "openHere": "Open {app} on this phone"
    },
    "drawer": {
      "close": "Close",
      "label": "Share your data with an identity app",
      "labelIssuance": "Add your data to an identity app"
    }
  }
}
